import React, { useState } from "react"
import {
  Container,
  Content,
  Header,
  Title,
  CloseButton,
  CloseIcon,
  Body,
} from "./style"
import { useModal, useHideModal } from "hooks"
import Spinner from "../Spinner"
import { useDispatch } from "react-redux"
import { clearState } from "redux/modules/modalwork/actions"
import { FiX } from "react-icons/fi"
import { classNames } from "utils/classNames"

export default () => {
  const { blured: modal, loading } = useModal()
  const { hideModal } = useHideModal()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  const handleCloseModal = () => {
    setTimeout(() => {
      dispatch(clearState())
      hideModal()
      setOpen(false)
    }, 200)
    setOpen(true)
  }

  return (
    <Container show={modal.show} position={modal.position}>
      <div className="hidden md:block">
        <div
          className={classNames(
            modal?.button == false ? "hidden" : "",
            "relative w-auto"
          )}
        >
          {!modal?.withHeader && (
            <div className="relative w-auto">
              <button
                className="absolute -top-[20.37rem] -right-[35rem] bg-white p-4 rounded-full z-[9999] flex justify-center items-center"
                onClick={() => {
                  dispatch(clearState())
                  hideModal()
                }}
              >
                <FiX color="#999999" size={18} />
              </button>
            </div>
          )}
        </div>
      </div>
      {modal.closable && (
        <button
          onClick={handleCloseModal}
          className="fixed z-[99999] top-2 right-2 bg-transparent"
        >
          <FiX color="white" size={35} />
        </button>
      )}
      <Content
        className="relative"
        show={modal.show}
        open={open}
        maxWidth={modal.maxWidth}
        rounded={modal.rounded}
        position={modal.position}
        overflow={modal.overflow}
        transparent={modal.transparent}
        height={modal.height}
        background={modal.background}
      >
        <Header visiblity={modal?.withHeader} background={modal.headerColor}>
          <Title background={modal.headerColor} className="noselect">
            {modal.title || ""}
          </Title>
          <CloseButton
            background={modal.headerColor}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </CloseButton>
        </Header>
        <Body maxHeight={modal.maxHeight} overflow={modal.overflow}>
          {loading ? (
            <Spinner maxHeight={"100%"} />
          ) : (
            (modal.body && <modal.body />) || "Body"
          )}
        </Body>
        <div
          className={classNames(
            modal.button == false ? "hidden" : "",
            "absolute -bottom-14 right-0 left-0 ml-auto mr-auto w-[50px] md:hidden flex justify-between"
          )}
        >
          <button
            className="bg-white p-4 rounded-full z-[9999] flex justify-center items-center"
            onClick={() => {
              dispatch(clearState())
              hideModal()
            }}
          >
            <FiX color="#999999" size={18} />
          </button>
        </div>
      </Content>
    </Container>
  )
}
